<template>
  <v-menu 
    v-model="menu"
    bottom 
    offset-y
    left
    lazy>
    <v-btn
      slot="activator"
      round
      flat
      small>
      <v-icon :color="menucolor">
        far fa-ellipsis-h
      </v-icon>
    </v-btn>

    <v-list
      dense>
      <!-- Menu Items for User -->
      <template v-for="item in menuItemsUser">
        <v-list-tile
          v-if="creatorId === userId"
          :key="item.title"
          
          :class="item.color"
          :disabled="item.disabled"
          @click.stop="getSelf()[item.method]()">
          <v-list-tile-avatar>
            <v-icon small>
              {{ item.icon }}
            </v-icon> 
          </v-list-tile-avatar>
          <v-list-tile-content>
            {{ item.title }}
          </v-list-tile-content>

          <v-dialog
            v-model="dialogDelete"
            class="roundedcard"
            lazy
            max-width="360">
            <v-card class="pa-3 roundedcard">
              <v-card-title
                class="headline">
                {{ headerText(post) }}
              </v-card-title>

              <v-card-text>
                <!-- {{ post }} -->
                <!-- TODO: Text/Translate -->

                Hierdurch wird die Aktivität entgültig gelöscht!
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="green darken-1"
                  dark
                  round
                  @click="dialogDelete = false">
                  <v-icon left>
                    fas fa-window-close
                  </v-icon>
                  <!-- TODO: Text/Translate -->

                  Abbrechen
                </v-btn>
                <v-spacer></v-spacer>

               

                <v-btn
                  round
                  
                  color="red darken-1"
                  dark
                  @click.prevent="getSelf()[item.deleteMethod]()">
                  <v-icon left>
                    fas fa-trash-alt
                    <!-- TODO: Text/Translate -->
                  </v-icon>Löschen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-tile>
      </template>

      <!-- Menu Items for Everyone -->
      <template v-for="item in menuItems">
        <v-list-tile
          v-if="creatorId !== userId"
          :key="item.title"
          :class="item.color"
          :disabled="item.disabled"
          @click.prevent="">
          <v-list-tile-avatar>
            <v-icon
              small>
              {{ item.icon }}
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            {{ item.title }}
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    post: {
      type: Object,
      required: true
    },
    menuItems: {
      type: Array,
      required: true
    },
    menuItemsUser: {
      type: Array,
      required: true
    },
    creatorId: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    menucolor: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      dialogDelete: false,
      menu: false
    }
  },
  methods: {
    ...mapActions([
      'deleteMoment',
      'deleteEvent'
    ]),
    getSelf() {
      return this
    },
    deleteDialog() {
      this.dialogDelete = true
      this.menu = false

    },
    deleteMomentButton() {
      this.deleteMoment({creatorId: this.creatorId, momentId: this.post.id})
      this.dialogDelete = false
    },
    deleteEventButton() {

      this.deleteEvent({creatorId: this.creatorId, eventId: this.post.id, post: this.post})
      this.dialogDelete = false
    },
    headerText(post) {
      return post.subject.charAt(0).toUpperCase() +  post.subject.slice(1) + ' ' + post.title + ' löschen?'
    }
  }
}
</script>
